import Vue from 'vue';
import Vuex from 'vuex';

import userStore from './users/userStore';
import onboardingUserStore from './users/onboardingUserStore';
import applicationClientStore from './applicationClient/applicationClientStore';
import accountsStore from './accounts/accountsStore';
import ordersStore from './orders/ordersStore';
import baaderStore from './baader/baaderStore';
import accountCreationsStore from './baader/accountCreationsStore';
import orderItemsStore from './baader/orderItemsStore';
import payoutItemsStore from './baader/payoutItemsStore';
import assetsStore from './baader/assetsStore';
import secondaryMarketOrdersStore from './baader/secondaryMarketOrdersStore';
import baaderAccountsStore from './baader/baaderAccountsStore';
import baaderAccountStore from './baader/baaderAccountStore';
import financialProductsStore from './financialProducts/financialProductsStore';
import tranchesStore from './financialProducts/tranchesStore';
import exposeStore from './financialProducts/financialProductExpose';
import fpvReportsStore from './ire/fpvReportsStore';
import ipSigningsStore from './ire/ipSigningsStore';
import ireDLQStore from './ire/ireDLQ';
import userDocumentsStore from './ire/userDocumentsStore';
import directSigningsStore from './ire/directSigningsStore';
import filesStore from './financialProducts/filesStore';
import securitiesStore from './securities/securitiesStore';
import identStore from './ident/identStore';
import bridgeSigningStore from './bridgeSigning/bridgeSigningStore';
import strategiesStore from './digitalDepots/strategies';
import strategiesDLQStore from './digitalDepots/strategiesDLQ';
import canceledSettlementsStore from './settlements/canceledSettlementsStore';
import strategiesSettlementStore from './settlements/strategiesSettlement';
import strategiesTrancheUtilizationStore from './settlements/strategiesTrancheUtilization';
import emoneyUsersStore from './emoneyUsers/emoneyUsersStore';
import tradesStore from './trades/tradesStore';
import vaultTransactionsStore from './vault/transactionsStore';
import vaultAssetsStore from './vault/assetsStore';
import vaultWalletsStore from './vault/walletsStore';
import sellOffersStore from './trades/sellOffersStore';
import buyOffersStore from './trades/buyOffersStore';
import baaderBankConfirmStore from './trades/baaderBankConfirmStore';
import cancellableTradesStore from './trades/cancellableTradesStore';
import payouts from './payout/payout';
import paybacks from './payout/payback';
import taxTraits from './payout/taxTrait';
import securities from './payout/security';
import companies from './payout/company';
import legalEntities from './payout/legalEntity';
import bankInformations from './payout/bankInformation';
import jea2020 from './payout/jea2020';
import jea2021 from './payout/jea2021';
import jea2022 from './payout/jea2022';
import jea2023 from './payout/jea2023';
import upvestStore from './upvest/upvestStore';
import registrationStore from './users/registrationStore';
import eieInvestmentsStore from './eieInvestments/eieInvestmentsStore';
import eieAssetsStore from './eieAssets/eieAssetsStore';

// CONFIGS
import templateTypeStore from './templateTypes/templateTypesStore';
import templateStore from './templates/templatesStore';
import emailStore from './emails/emailsStore';
import blockchainOrderStore from './blockchainOrders/blockchainOrderStore';
import blockchainPendingTradesStore from './trades/blockchainPendingTradesStore';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    accountsStore,
    applicationClientStore,
    baaderBankConfirmStore,
    baaderStore,
    accountCreationsStore,
    orderItemsStore,
    payoutItemsStore,
    assetsStore,
    secondaryMarketOrdersStore,
    baaderAccountsStore,
    baaderAccountStore,
    financialProductsStore,
    tranchesStore,
    exposeStore,
    fpvReportsStore,
    ipSigningsStore,
    ireDLQStore,
    userDocumentsStore,
    directSigningsStore,
    cancellableTradesStore,
    blockchainOrderStore,
    blockchainPendingTradesStore,
    bridgeSigningStore,
    emailStore,
    emoneyUsersStore,
    identStore,
    ordersStore,
    securitiesStore,
    sellOffersStore,
    buyOffersStore,
    strategiesDLQStore,
    strategiesStore,
    canceledSettlementsStore,
    strategiesSettlementStore,
    strategiesTrancheUtilizationStore,
    templateStore,
    templateTypeStore,
    tradesStore,
    userStore,
    filesStore,
    onboardingUserStore,
    payouts,
    paybacks,
    taxTraits,
    securities,
    companies,
    legalEntities,
    bankInformations,
    jea2020,
    jea2021,
    jea2022,
    jea2023,
    upvestStore,
    vaultTransactionsStore,
    vaultAssetsStore,
    vaultWalletsStore,
    registrationStore,
    eieInvestmentsStore,
    eieAssetsStore,
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js